export default __webpack_public_path__ + "static/media/BRU.64d00155.svg";